import { ContestPrize } from '@beable/roster-backend-client-v1';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import ContestPrizeService from '../../../services/ContestPrizeService';
import Header from '../../Header/Header';
import { SubHeader } from '../../Common/Layout/SubHeader';
import { BasePaper } from '../../Common/Layout/BasePaper';
import ContestPrizeTable from './ContestPrizeTable';
import EditContestPrizeDialog from './EditContestPrizeDialog';
import { getStyles } from './styles';


export default function ManagePrizes() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [ contestPrizes, setContestPrizes ] = useState<ContestPrize[]>([]);
  const [ editableContestPrize, setEditableContestPrize ] = useState<ContestPrize | null>(null);
  const [ isCreateDialogOpen, setIsCreateDialogOpen ] = useState<boolean>(false);
  const isEditContestDialogOpen = editableContestPrize != null;

  const refreshContestPrizeList = async () => {
    const allContestPrizes = await ContestPrizeService.getAllContestPrizes();
    setContestPrizes(allContestPrizes || []);
  };

  useEffect(() => {
    refreshContestPrizeList();
  }, []);

  const onDeleteContestPrize = async (contestPrize: ContestPrize) => {
    await ContestPrizeService.deleteContestPrize(contestPrize);
    refreshContestPrizeList();
  };

  const onEditContestPrize = (contestPrize: ContestPrize) => {
    setEditableContestPrize(contestPrize);
  };

  const onEditContestDialogClose = () => {
    setEditableContestPrize(null);
    refreshContestPrizeList();
  };

  const onEditContestDialogSave = async (updatedContestPrize: ContestPrize) => {
    await ContestPrizeService.saveContestPrize(updatedContestPrize);
    onEditContestDialogClose();
  };

  const onCreateContestDialogClose = () => {
    setIsCreateDialogOpen(false);
    refreshContestPrizeList();
  };

  const onCreateContestDialogSave = async (newContestPrize: ContestPrize) => {
    await ContestPrizeService.createContestPrize(newContestPrize);
    onCreateContestDialogClose(); 
  };

  return (
    <Box sx={styles.root}>
      <Header />
      <SubHeader>
        <Typography variant='h6' component='span'>Manage Contest Prizes</Typography>
      </SubHeader>
      <Grid container sx={{
        justifyContent: 'center'
      }}>
        <Grid size={10}>
          <BasePaper>
            <ContestPrizeTable 
              contestPrizes={contestPrizes} 
              onEditContestPrize={onEditContestPrize}
              onDeleteContestPrize={onDeleteContestPrize}
            />
            <Button
                variant='contained'
                color='primary'
                aria-label='add new contest prize'
                title='Add New Contest Prize'
                onClick={() => { setIsCreateDialogOpen(true); }}
              >
                Add New
            </Button>
          </BasePaper>
        </Grid>
      </Grid>
      { editableContestPrize && <EditContestPrizeDialog 
          title='Edit Contest Prize'
          isOpen={isEditContestDialogOpen} 
          onClose={onEditContestDialogClose} 
          contestPrize={editableContestPrize}
          onSave={onEditContestDialogSave}
        />
      }
      { isCreateDialogOpen && <EditContestPrizeDialog 
          title='Add New Contest Prize'
          isOpen={isCreateDialogOpen} 
          onClose={onCreateContestDialogClose} 
          onSave={onCreateContestDialogSave}
        />
      }
    </Box>
  );
}